import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';

import UserSessionStore from 'flux/stores/UserSessionStore';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';

import ModalHelper from './modalHelper';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import ItemNumber from 'main/components/show/cuesheet.responsive/itemNumber.jsx';
import ItemTitle from 'main/components/show/cuesheet.responsive/itemTitle.jsx';
import Duration from 'main/components/show/cuesheet.responsive/itemDuration.jsx';
import StartTime from 'main/components/show/cuesheet.responsive/itemStartTime.jsx';
import PresetDuration from 'main/components/show/cuesheet.responsive/itemPresetDuration.jsx';
import ItemDescription from 'main/components/show/cuesheet.responsive/itemDescription.jsx';
import ItemNote from 'main/components/show/cuesheet.responsive/itemNote.jsx';
import ItemDataCell from 'main/components/show/cuesheet.responsive/itemDataCell.jsx';
import ColumnHeader from 'main/components/show/cuesheet.responsive/columnHeader.jsx';
import ItemCog from 'main/components/show/cuesheet.responsive/itemCog.jsx';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';

import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin';

import Tappable from 'react-tappable';
import keyIn from 'shared/lib/immutable/keyIn';
import { Col, Panel, Button } from 'bootstrap';

import {
  NoteColumnHeaderTitle,
  EditableCellTypes,
} from 'flux/stores/cuesheet/CuesheetConstants';

export default React.createClass({
  mixins: [
    Reflux.connectFilter(UserSessionStore, 'userId', (state) =>
      state.get('_id'),
    ),
    Reflux.connectFilter(CuesheetResponsiveStore, 'showDetail', (st) =>
      st.get('showDetail'),
    ),
    Reflux.connectFilter(EventViewStore, 'event', (st) =>
      st.filter(keyIn('twentyFourHourClock')),
    ),
    Reflux.connectFilter(CuesheetStore, 'cueState', (state) => {
      let selectedRow = ModalHelper.itemConnectFilter(
        (row) =>
          row.getIn(['selected', 'type']) === EditableCellTypes.ItemTitle,
      )(state);

      if (!selectedRow) {
        //if nothing selected, take the first
        selectedRow = ModalHelper.itemConnectFilter(() => true)(state);
      }

      if (selectedRow) {
        selectedRow.itemNumber = CuesheetMixin.getItemNumberAdjusted(
          selectedRow.item,
          selectedRow.rowIndex,
          state,
        );
        selectedRow.isTracked = state.getIn([
          'rows',
          selectedRow.rowIndex,
          'tracked',
        ]);
      }

      return {
        selectedRow,
        rows: state.get('rows'),
        columns: state.get('columns'),
        columnOrder: state.get('columnOrder'),
        userSettings: state.get('userSettings'),
        displayItemDescriptions: state.getIn([
          'show',
          'displayItemDescriptions',
        ]),
        durationDisplayType: state.getIn(['show', 'durationDisplayType']),
        presetDurationDisplayType: state.getIn([
          'show',
          'presetDurationDisplayType',
        ]),
        displayDuration: state.getIn(['show', 'displayDuration']),
      };
    }),
  ],

  render() {
    const showDetailForSmallScreens = this.state.showDetail;

    return (
      <div
        className={classNames({
          'hidden-xs': showDetailForSmallScreens === false,
        })}
      >
        <Col xs={24} sm={12} md={12} lg={12} className="csr-cue-detail">
          {this._getItemDetailNode()}
        </Col>
      </div>
    );
  },

  _getItemDetailNode() {
    return <div>{this._getItemNode()}</div>;
  },

  _getItemNode() {
    if (!this._hasState('selectedRow')) return null;

    const { rowIndex, item } = this.state.cueState.selectedRow;
    const { userId } = this.state;

    return (
      <div className="csr-cue-detail-wrapper">
        <div className="csr-cue-detail-nav-controls">
          <div className="csr-cue-detail-back visible-xs">
            <Icon
              className="detail-arrow-left"
              name="angle-left"
              size={3}
              onClick={() => CuesheetResponsiveActions.hideCueDetail()}
            >
              {' '}
              <span className="arrow-title-items">All Items</span>
            </Icon>
          </div>
          {this._getNextRowButtonNode(rowIndex)}
        </div>
        <div className="cue-detail-scroll-pane">
          <div
            style={Object.assign(
              {},
              HighlightCellHelper.getGlobalHighlightStyle(item),
              HighlightCellHelper.getPersonalHighlightStyle(item, userId),
            )}
            className={classNames('csr-cue-detail-item-summary', {
              'csr-cue-detail-item-tracked': this._getStateField('selectedRow')
                .isTracked,
            })}
          >
            <div>
              <div className="csr-item-wrapper">
                <div className="csr-cue-detail-item-title">
                  {this._getItemNumberNode()}{' '}
                  <span className="csr-item-num-title-separator"> - </span>
                  {this._getItemTitleNode()}
                </div>
                <div className="csr-item-settings">
                  {this._getItemCogNode()}
                </div>
                <div className="csr-item-timing">
                  <div className="csr-item-start-time">
                    {this._getItemStartTimeNode()}
                  </div>
                  <div className="csr-item-preset-dur">
                    {this._getItemPresetDurationNode()}
                  </div>
                  <div className="csr-item-dur">
                    {this._getItemDurationNode()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this._getItemDescriptionNode()}
          {this._getItemNoteNode()}
          <div className="csr-detail-data-items">{this._getColumnNodes()}</div>

          <div className="btn-csr-detail-column">
            <Button onClick={() => CuesheetColumnActions.showColumns()}>
              <Icon name="eye" size={2} />
              Show All Columns
            </Button>

            {this._isNoteHidden() ? (
              <Button onClick={() => CuesheetColumnActions.showNoteColumn()}>
                <Icon name="eye" size={2} />
                Show {NoteColumnHeaderTitle}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    );
  },

  _getNextRowButtonNode(rowIndex) {
    const { rows } = this.state.cueState;

    //if we're on the final row of a show, do not render the
    //next button
    if (rowIndex + 1 === rows.size) return null;

    return (
      <div className="csr-cue-detail-next visible-xs">
        <Icon
          className="detail-arrow-right"
          name="angle-right"
          size={3}
          onClick={() =>
            CuesheetCellActions.selectItemCell(
              rowIndex + 1,
              EditableCellTypes.ItemTitle,
            )
          }
        >
          {' '}
          <span className="arrow-title-next">Next</span>
        </Icon>
      </div>
    );
  },

  _getItemNumberNode() {
    const { item, rowIndex } = this.state.cueState.selectedRow;

    return (
      <ItemNumber itemNumber={item.get('numberAdjusted')} rowIndex={rowIndex} />
    );
  },

  _getItemStartTimeNode() {
    if (!this.state.event) return null;

    const { item, rowIndex } = this.state.cueState.selectedRow;

    return (
      <StartTime
        twentyFourHourClock={this.state.event.get('twentyFourHourClock')}
        rowIndex={rowIndex}
        item={item}
      />
    );
  },

  _getItemPresetDurationNode() {
    const { item, rowIndex } = this.state.cueState.selectedRow;
    const { presetDurationDisplayType } = this.state.cueState;

    return (
      <PresetDuration
        presetDurationDisplayType={presetDurationDisplayType}
        rowIndex={rowIndex}
        item={item}
      />
    );
  },

  _getItemDurationNode() {
    const { item, rowIndex } = this.state.cueState.selectedRow;
    const { displayDuration, durationDisplayType } = this.state.cueState;

    if (!displayDuration) return null;

    return (
      <Duration
        rowIndex={rowIndex}
        durationDisplayType={durationDisplayType}
        item={item}
      />
    );
  },

  _getItemDescriptionNode() {
    const { item, rowIndex, rowId } = this.state.cueState.selectedRow;

    const isHidden = this._isDescriptionHidden();

    if (isHidden) return null;

    return (
      <Panel
        className="csr-detail-column-item"
        header={this._getDescriptionNodeHeaderNode()}
      >
        <ItemDescription item={item} rowIndex={rowIndex} rowId={rowId} />
      </Panel>
    );
  },

  _getDescriptionNodeHeaderNode() {
    return <div className="csr-note-cell-header">Description</div>;
  },

  _getItemNoteNode() {
    const { userId } = this.state;
    const { item, rowIndex } = this.state.cueState.selectedRow;

    const isHidden = this._isNoteHidden();
    if (isHidden) return null;

    return (
      <Panel
        className={classNames({
          'panel-content-hidden': isHidden,
          'csr-detail-column-item': true,
        })}
        header={this._getItemNodeHeaderNode()}
      >
        <Tappable
          onTap={() =>
            CuesheetCellActions.startEditingItemCell(
              rowIndex,
              EditableCellTypes.ItemNote,
            )
          }
        >
          <ItemNote item={item} rowIndex={rowIndex} userId={userId} />
        </Tappable>
      </Panel>
    );
  },

  _getItemNodeHeaderNode() {
    return (
      <div className="csr-note-cell-header">
        {NoteColumnHeaderTitle}
        <Tappable
          className="pull-right"
          onClick={() => CuesheetColumnActions.hideNoteColumn()}
        >
          <Icon size={2} name="eye-slash" />
        </Tappable>
      </div>
    );
  },

  _getItemCogNode() {
    const { rowIndex } = this.state.cueState.selectedRow;

    return <ItemCog rowIndex={rowIndex} />;
  },

  _getItemTitleNode() {
    const { item, rowIndex } = this.state.cueState.selectedRow;

    return <ItemTitle item={item} rowIndex={rowIndex} />;
  },

  _getColumnNodes() {
    if (!this._hasState('columns')) return null;

    return this._getStateField('columns').map(this._getColumnNode);
  },

  _getColumnNode(column, i) {
    const columnId = column.get('_id');

    const { item, rowIndex } = this.state.cueState.selectedRow;

    const isHidden = this._isHidden(columnId),
      content =
        isHidden === false ? (
          <Tappable
            onTap={() =>
              CuesheetCellActions.startEditingDataCell(rowIndex, columnId)
            }
          >
            <ItemDataCell item={item} rowIndex={rowIndex} columnId={columnId} />
          </Tappable>
        ) : (
          <em>{'{Hidden cell}'}</em>
        );

    return (
      <Panel
        className={classNames('csr-detail-data-column-item', {
          'panel-content-hidden': isHidden,
          'csr-detail-column-item': true,
        })}
        header={this._getColumnHeaderNode(column, i)}
      >
        {content}
      </Panel>
    );
  },

  _getColumnHeaderNode(column) {
    return <ColumnHeader column={column} />;
  },

  _isHidden(columnId) {
    const visibleColumnList = this._getStateField('columnOrder');

    return visibleColumnList.indexOf(columnId) === -1;
  },

  _hasState(field) {
    return !(
      !this.state ||
      !this.state.cueState ||
      !this._getStateField(field)
    );
  },

  _getItemState() {
    return this._getStateField('selectedRow').item;
  },

  _getStateField(field) {
    return this.state.cueState[field];
  },

  _isNoteHidden() {
    const userSettings = this._getStateField('userSettings');
    return userSettings.getIn(['noteColumn', 'hidden']);
  },

  _isDescriptionHidden() {
    return this._getStateField('displayItemDescriptions') !== true;
  },
});
